import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { environment } from "../../../../environments/environment";
import { Result } from "../../../shared/interfaces/result.interface";
import { IUserDetails } from "../_interfaces/user.interface";

@Injectable({ providedIn: "root" })
export class UserService {
    basePath = `${environment.url}/user`;

    constructor(private http: HttpClient) {}

    requestOtp$(phone: string): Observable<boolean> {
        const payload = {
            phone,
        };

        return this.http.post<Result<boolean>>(`${this.basePath}/requestOtp`, payload).pipe(map((res) => res.data));
    }

    verifyOtp$(phone: string, otp: string): Observable<{ fullName: string; email: string }> {
        const payload = {
            phone,
            otp,
        };

        return this.http
            .post<Result<{ fullName: string; email: string }>>(`${this.basePath}/verifyOtp`, payload)
            .pipe(map((res) => res.data));
    }

    login$(email: string, password: string): Observable<string> {
        const payload = {
            email,
            password,
        };

        return this.http.post<Result<string>>(`${this.basePath}/login`, payload).pipe(map((res) => res.data));
    }

    getUserDetails$(): Observable<IUserDetails> {
        return this.http.get<Result<IUserDetails>>(`${this.basePath}/getUserDetails`).pipe(map((res) => res.data));
    }
}
